import React, { useState } from 'react'
import { reduxForm, Field } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
//import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Grid, Button } from '@material-ui/core';
import PasswordBarLineIndicator from '../Complements/PasswordBarLineIndicator';
import UsernameConditionsIndicator from './UsernameConditionsIndicator';
import RenderTextFieldDefaultRedux from '../Complements/RenderTextFieldDefaultRedux';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
}));

const validate = values => {
    const error = {}
    //console.log(values)
    if (!values.username) {
        return "El campo nombre de usuario es obligatorio."
    }
    return error
}

const validateConditions = (value, allValues, props) => {

    const { handleValidationUsername } = props

    handleValidationUsername(value)
}

const validateSpacesBlack = (value, allValues, props) => {

    if (/\s/.test(value) === true) {
        return "Este campo no debe contener espacios en blanco."
    } else {
        return undefined
    }
}

const UsernameChangeForm = props => {

    const [progressBarColors] = useState(["#EFEFEF", "red", "orange", "yellow", "green"])

    const classes = useStyles();

    const {
        handleSubmit,
        invalid,
        progress,
        // numberValid,
        // characterValid,
        // identificationValid,
        // numberCharacters,
        // charNumberValid,
        validators
    } = props

    return (
        <div>
            <form className={classes.form} onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>

                        <Field
                            name="username"
                            id="username"
                            validate={[validateSpacesBlack, validateConditions]}
                            autoFocus={true}
                            component={RenderTextFieldDefaultRedux}
                            label={"Nombre de Usuario"}
                            fullWidth

                        />

                    </Grid>

                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <PasswordBarLineIndicator progress={progress} progresscolor={progressBarColors[progress / 25]} />
                    </Grid>

                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <UsernameConditionsIndicator
                            validators={validators}
                        // numberValid={numberValid}
                        // characterValid={characterValid}
                        // identificationValid={identificationValid}
                        // charNumberValid={charNumberValid}
                        // numberCharacters={numberCharacters}
                        />
                    </Grid>

                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            //fullWidth
                            className={classes.buttonStandard}
                            disabled={invalid || progress === 100 ? false : true}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

const UsernameChangeFormReduxForm = reduxForm(
    {
        form: 'UsernameChangeForm',
        validate
    }
)(UsernameChangeForm)
export default UsernameChangeFormReduxForm
